module.exports = __webpack_public_path__ + "static/media/comp.ab562ce0.png";